import {useCallback, useContext} from "react";
import {ToastContext} from "../contexts/toastContext";

export function useToasts() {
    const { pushToastRef } = useContext(ToastContext);
    return {
        pushToast: useCallback(
            (toast) => {
                pushToastRef.current(toast);
            },
            [pushToastRef]
        ),
    };
}